import { render, staticRenderFns } from "./web-browser-bar.html?vue&type=template&id=4e4f70d8&scoped=true&"
import script from "./web-browser-bar.js?vue&type=script&lang=js&"
export * from "./web-browser-bar.js?vue&type=script&lang=js&"
import style0 from "./web-browser-bar.scss?vue&type=style&index=0&id=4e4f70d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f70d8",
  null
  
)

export default component.exports